import React from "react";
import "./Login.css";
import { Button } from "@material-ui/core";
import { provider, auth } from "../../Firebase/firebase";
import { useStateValue } from "../../Context/StateProvider";
import { actionTypes } from "../../Context/reducer";

const Login = (props) => {
  const [state, dispatch] = useStateValue();

  const signIn = () => {
    auth
      .signInWithPopup(provider)
      .then((result) => {
        console.log("result : ", result);
        dispatch({
          type: actionTypes.SET_USER,
          user: result.user,
        });
      })
      .catch((error) => {
        alert(error.message);
      });
  };

  return (
    <div className="login">
      <div className="login__container">
        <img src={require("../../Resource/Images/slack.jpg")} alt="" />
        <h1>Sign in to Slack Clone</h1>
        <Button onClick={signIn}>Sign in with Google</Button>
      </div>
    </div>
  );
};

export default Login;
